import { Metrics as CustomerDataObjectsMetrics } from 'customer-data-objects/metrics/Metrics';
import { Metrics } from './Metrics';
import { getRequestErrorClass } from './requestMetrics';
export const incrementAutosaveSuccessMetric = batchSize => {
  Metrics.counter('autosave-property-success').increment();
  Metrics.histogram('autosave-property-batch-size').update(batchSize);
};
export const incrementAutosaveFailureMetric = error => {
  Metrics.counter('autosave-property-failure', {
    errorClass: getRequestErrorClass(error)
  }).increment();
};
export const incrementAutosaveOnSaveFailureMetric = () => {
  Metrics.counter('autosave-property-onsave-failure').increment();
};
export const incrementAutosaveUndoSuccessMetric = () => {
  Metrics.counter('autosave-property-undo-success').increment();
};
export const incrementAutosaveUndoFailureMetric = () => {
  Metrics.counter('autosave-property-undo-failure').increment();
};
export const incrementAutosaveUndoCallbackFailureMetric = () => {
  Metrics.counter('autosave-property-undo-callback-failure').increment();
};
export const incrementAutosaveEmptyParsedUpdatesMetric = () => {
  Metrics.counter('autosave-empty-parsed-updates').increment();
};
export const incrementAutosaveClearPendingRequestsMetric = () => {
  Metrics.counter('autosave-clear-pending-requests').increment();
};
export const incrementAutosavePendingEditsBeforeUnloadMetric = () => {
  Metrics.counter('autosave-pending-edits-and-beforeunload').increment();
};
export const incrementAutosaveSavingBeforeUnloadMetric = () => {
  CustomerDataObjectsMetrics.counter('autosave-saving-and-beforeunload').increment();
};